import React from 'react'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { withRouter } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import PageLoading from 'core/components/page-loading'

import styled from 'styled-components'
import { List, Radio, Row, Col, Alert } from 'core/components/ui'
import { font, greys } from 'assets/themes/theme-default'

const ClickableRow = styled(Row)`
  cursor: pointer;
`
const ColDataInput = styled(Col)`
  padding-top: 2px;
  text-align: center;
`

const ColDataLabel = styled(Col)`
  color: ${greys.dark1};
  font-weight: ${font.weight.base};
  line-height: ${isMobile && 'normal'};
`
const StyledList = styled(List)`
  height: ${isMobile && '230px'};
  overflow: ${isMobile && 'scroll'};
  margin-bottom: ${isMobile && '20px'};
`
const ModalContentListVehicles = props => {
  const {
    registrationVehiculeSelected,
    handleChangeRegistrationVehiculeSelected,
    vehiclesList,
    intl,
    error
  } = props

  return (
    <>
      {error && (
        <Alert
          message={intl.formatMessage({ id: 'vehicle-informations-error' })}
          type="error"
          data-test="vehicle-list-error"
        />
      )}
      {vehiclesList ? (
        <StyledList
          dataSource={_.sortBy(vehiclesList, ['version', 'trim', 'beginPrice'])}
          renderItem={item => {
            const { make, version, trim, doors } = item
            let label = `${make} ${version}`

            if (trim) {
              label = label.concat(' ', trim)
            }
            if (doors) {
              label = label.concat(
                ' ',
                `(${intl.formatMessage(
                  { id: 'stock-vehicle-detail-list-infos-doors-value-2' },
                  { doors }
                )})`
              )
            }

            return (
              <List.Item>
                <ClickableRow
                  type="flex"
                  align="top"
                  onClick={() => handleChangeRegistrationVehiculeSelected(item)}
                  style={{ width: '100%', alignItems: 'center' }}
                >
                  <ColDataInput span={isMobile ? 3 : 2}>
                    <Radio
                      checked={
                        !registrationVehiculeSelected
                          ? false
                          : item === registrationVehiculeSelected
                      }
                    />
                  </ColDataInput>
                  <ColDataLabel span={isMobile ? 21 : 20}>{label}</ColDataLabel>
                </ClickableRow>
              </List.Item>
            )
          }}
        />
      ) : (
        <PageLoading />
      )}
    </>
  )
}

ModalContentListVehicles.defaultProps = {
  registrationVehiculeSelected: null,
  error: false,
}

ModalContentListVehicles.propTypes = {
  intl: PropTypes.shape().isRequired,
  registrationVehiculeSelected: PropTypes.shape({
    make: PropTypes.string.isRequired,
    // modelGroup: PropTypes.string.isRequired,
    model: PropTypes.string.isRequired
  }),
  handleChangeRegistrationVehiculeSelected: PropTypes.func.isRequired,
  vehiclesList: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  error: PropTypes.bool,
}

export default withRouter(injectIntl(ModalContentListVehicles))
